import { COVID_ROOT_PATH } from '../paths';

/**
 * @deprecated Use `/care/dashboard` instead.
 * import { CARE_DASHBOARD_PATH } from 'ui/Care/paths';
 */
export const DEPRECATED_COVID_USER_DASHBOARD_ROOT_PATH = `${COVID_ROOT_PATH}/dashboard`;

/**
 * @deprecated Use `/care/test-status` instead.
 * import { CARE_DASHBOARD_STATUS_PATH } from 'ui/Care/paths';
 */
export const DEPRECATED_COVID_USER_TEST_STATUS_PATH = `${DEPRECATED_COVID_USER_DASHBOARD_ROOT_PATH}/status`;
